import React from 'react';
import './Input.css';

const TextArea = ({
  title,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
  className = "",
  rows = 4,
  ...props
}) => {
  return (
    <div className={`input-container ${className}`}>
      {title && (
        <label className="input-title">
          {title}
          {required && <span className="required-asterisk">*</span>}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        className={`input-field textarea-field ${error ? 'input-error' : ''}`}
        {...props}
      />
      {error && (
        <div className="input-error-message">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextArea; 